const VERSION_ACTUAL = process.env.VUE_APP_BUILD_VERSION
const INTERVALO_MS = 5 * 60 * 1000

// true  = recarga en cuanto detecta la nueva version (puede perder datos de formularios abiertos)
// false = muestra el banner y recarga en la siguiente navegacion o cuando el usuario presione el boton
const FORZAR_INMEDIATO = false

const ID_BANNER = 'oasis-aviso-version'
const ID_ESTILOS = 'oasis-aviso-version-estilos'

let hayNuevaVersion = false
let avisoMostrado = false

const ESTILOS = `
#${ID_BANNER} {
  position: fixed;
  left: 24px;
  bottom: 24px;
  z-index: 100000;
  display: flex;
  align-items: center;
  gap: 12px;
  max-width: 460px;
  padding: 12px 12px 12px 20px;
  background: #323232;
  color: #ffffff;
  border-radius: 6px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35);
  font-size: 14px;
  line-height: 1.4;
  opacity: 0;
  transform: translateY(150%);
  transition: transform 0.3s ease, opacity 0.3s ease;
}
#${ID_BANNER}.oav-visible {
  opacity: 1;
  transform: translateY(0);
}
#${ID_BANNER} .oav-texto {
  flex: 1;
}
#${ID_BANNER} .oav-titulo {
  display: block;
  font-weight: 600;
  margin-bottom: 2px;
}
#${ID_BANNER} .oav-detalle {
  color: #cfcfcf;
  font-size: 13px;
}
#${ID_BANNER} .oav-btn-actualizar {
  background: transparent;
  border: 0;
  border-radius: 4px;
  color: #8ab4f8;
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.5px;
  padding: 8px 10px;
  text-transform: uppercase;
  white-space: nowrap;
}
#${ID_BANNER} .oav-btn-actualizar:hover {
  background: rgba(138, 180, 248, 0.15);
}
#${ID_BANNER} .oav-btn-actualizar:disabled {
  color: #9e9e9e;
  cursor: default;
}
#${ID_BANNER} .oav-btn-cerrar {
  background: transparent;
  border: 0;
  color: #bdbdbd;
  cursor: pointer;
  font-size: 20px;
  line-height: 1;
  padding: 4px 8px;
}
#${ID_BANNER} .oav-btn-cerrar:hover {
  color: #ffffff;
}
@media (max-width: 600px) {
  #${ID_BANNER} {
    left: 12px;
    right: 12px;
    bottom: 12px;
    max-width: none;
  }
}
`

function urlVersion() {
  return (process.env.BASE_URL || '/') + 'version.json?t=' + Date.now()
}

function recargar(url) {
  if (url) {
    window.location.assign(url)
  } else {
    window.location.reload()
  }
}

function insertarEstilos() {
  if (document.getElementById(ID_ESTILOS)) return
  const style = document.createElement('style')
  style.id = ID_ESTILOS
  style.textContent = ESTILOS
  document.head.appendChild(style)
}

function ocultarBanner(banner) {
  banner.classList.remove('oav-visible')
  setTimeout(function () {
    if (banner.parentNode) banner.parentNode.removeChild(banner)
  }, 300)
}

function mostrarAviso() {
  if (avisoMostrado || !document.body) return
  avisoMostrado = true

  insertarEstilos()

  const banner = document.createElement('div')
  banner.id = ID_BANNER
  banner.setAttribute('role', 'alert')
  banner.innerHTML =
    '<div class="oav-texto">' +
      '<span class="oav-titulo">Hay una nueva version de Oasis Cloud</span>' +
      '<span class="oav-detalle">Guarde su trabajo y actualice para usar la version mas reciente.</span>' +
    '</div>' +
    '<button type="button" class="oav-btn-actualizar">Actualizar</button>' +
    '<button type="button" class="oav-btn-cerrar" title="Cerrar">&times;</button>'

  const btnActualizar = banner.querySelector('.oav-btn-actualizar')
  const btnCerrar = banner.querySelector('.oav-btn-cerrar')

  btnActualizar.addEventListener('click', function () {
    btnActualizar.disabled = true
    btnActualizar.textContent = 'Actualizando...'
    recargar()
  })

  // Cerrar solo oculta el banner; la actualizacion se aplica igual en la siguiente navegacion
  btnCerrar.addEventListener('click', function () {
    ocultarBanner(banner)
  })

  document.body.appendChild(banner)

  // Se agrega la clase en el siguiente frame para que corra la animacion de entrada
  window.requestAnimationFrame(function () {
    window.requestAnimationFrame(function () {
      banner.classList.add('oav-visible')
    })
  })
}

function verificarVersion() {
  if (hayNuevaVersion) return Promise.resolve(true)

  return fetch(urlVersion(), { cache: 'no-store' })
    .then(function (resp) {
      return resp.ok ? resp.json() : null
    })
    .then(function (data) {
      if (data && data.version && String(data.version) !== String(VERSION_ACTUAL)) {
        hayNuevaVersion = true
        if (FORZAR_INMEDIATO) {
          recargar()
        } else {
          mostrarAviso()
        }
      }
      return hayNuevaVersion
    })
    .catch(function () {
      return hayNuevaVersion
    })
}

export function iniciarControlVersion(router) {
  if (process.env.NODE_ENV !== 'production' || !VERSION_ACTUAL) return

  // Si ya hay version nueva, en lugar de navegar dentro de la SPA se hace carga completa
  router.beforeEach(function (to, from, next) {
    if (hayNuevaVersion) {
      next(false)
      recargar(router.resolve(to.fullPath).href)
      return
    }
    next()
  })

  verificarVersion()
  setInterval(verificarVersion, INTERVALO_MS)

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      verificarVersion()
    }
  })
}
